import { render, staticRenderFns } from "./PurChaseRecivingDetails.vue?vue&type=template&id=ce6e687c&scoped=true&"
import script from "./PurChaseRecivingDetails.vue?vue&type=script&lang=js&"
export * from "./PurChaseRecivingDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurChaseRecivingDetails.vue?vue&type=style&index=0&id=ce6e687c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6e687c",
  null
  
)

export default component.exports